module.exports = __webpack_public_path__ + "static/media/oval.2bb0caaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/IncreaseValueOverTimeResources/oval.svg
// module id = 76
// module chunks = 0